import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ViewsNodeServiceCards from 'src/components/ViewsNodeServiceCards/ViewsNodeServiceCards';
import imgFallback from 'src/utils/image';

export const ServicesHero = ({ hero }) => (
  <Container fluid className="bg-shapes-banner px-0 pt-7">
    <Container className="py-8">
      <Row>
        {hero && (
          <Col xs={12} md={8} lg={4} className="py-lg-6 mb-6">
            <h1 className="h2 mb-6">{hero.title}</h1>
            <div className="text-muted">
              <PortableText value={hero.description} />
              {hero.logo && (
                <div className="mt-3">
                  <GatsbyImage
                    alt={hero.logo?.alt ?? ''}
                    style={{ maxWidth: '350px' }}
                    image={hero.logo?.image?.asset?.gatsbyImageData ?? imgFallback}
                  />
                </div>
              )}
            </div>
          </Col>
        )}
        <Col xs={12} lg={8}>
          <ViewsNodeServiceCards />
        </Col>
      </Row>
    </Container>
  </Container>
);
